export default "__VITE_ASSET__h51Ctm$0__"